export const environment = {
  production: false,
  guaranteesV2Enabled: undefined as boolean | undefined,
  healthManagerApiUrl: 'https://api.staging.getlilo.io/health-manager',
  authorizationApiUrl: 'https://api.staging.getlilo.io/access',
  protectedApiUrl: 'https://api.staging.getlilo.io/protected',
  guaranteesHubUrl: 'https://api.staging.getlilo.io/hubs/guarantees',
  adminPortalUrl: 'https://admin-portal-v2.staging.getlilo.io',
  connectChatUrl: 'https://agent.connect-stg.twelvco.world',
  communicationServiceUrl: 'https://lilo-common-staging-cs.europe.communication.azure.com/',
  firebase: {
    apiKey: 'AIzaSyBRx4AJO7LMlZjeluaa2N8RuHtQBplc_7E',
    authDomain: 'lilo-staging-9d37f.firebaseapp.com',
    projectId: 'lilo-staging-9d37f',
    storageBucket: 'lilo-staging-9d37f.appspot.com',
    messagingSenderId: '102050866616',
    appId: '1:102050866616:web:50633aa50df13d756bdb4d',
    measurementId: 'G-MCZ851T254',
    vapidKey: 'BGvlSVZx14p-SvE5AxDmgIyTxqJab4p9Hz0Y3zw-W6m5_qOxtJril7K2kK3kdJ62_zVvexIgwyPHRuKm46M6jN8',
  },
};
